export class SearchBatchloading {
  partnerId: number;
  enterpriseId: number;
}
